import React, { useRef } from "react";
import { Container, ImgBox1, SignContainer, TextBox1, TextBox2, Wrap } from "./style";
import { useTranslation } from "react-i18next";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com2 = () => {
  const { t } = useTranslation("howToGetSketch");
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  useScrollFadeIn(ref1, ref2, ref3, ref4);
  return (
    <Container>
      <TextBox1>
        <span>{t("2-1")}</span>
        <span>{t("2-2")}</span>
      </TextBox1>
      <Wrap>
        <SignContainer ref={ref1} className="fade-in">
          <TextBox2>
            <div>{t("2-3")}</div>
            <div>{t("2-4")}</div>
            <div>{t("2-5")}</div>
            <div>{t("2-6")}</div>
          </TextBox2>
          <ImgBox1 loading="lazy">
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/3ed05061HowToGetSKET_2.png"
              alt="signUp_2"
            />
          </ImgBox1>
        </SignContainer>
        <SignContainer ref={ref2} className="fade-in">
          <TextBox2>
            <div>{t("2-7")}</div>
            <div>{t("2-8")}</div>
            <div>{t("2-9")}</div>
          </TextBox2>
          <ImgBox1 loading="lazy">
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/c7aa0ff4HowToGetSKET_3.png"
              alt="signUp_3"
            />
          </ImgBox1>
        </SignContainer>
        <SignContainer ref={ref3} className="fade-in">
          <TextBox2>
            <div>{t("2-10")}</div>
            <div>{t("2-11")}</div>
            <div>
              <span>{t("2-12")}</span>
              <span>{t("2-12-1")}</span>
            </div>
            <div>{t("2-13")}</div>
          </TextBox2>
          <ImgBox1 loading="lazy">
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/82906e13HowToGetSKET_4.png"
              alt="KoreaMarket_graph"
            />
          </ImgBox1>
        </SignContainer>
        <SignContainer ref={ref4} className="fade-in">
          <TextBox2>
            <div>{t("2-14")}</div>
            <div>{t("2-15")}</div>
            <div>{t("2-16")}</div>
            <div>{t("2-17")}</div>
          </TextBox2>
          <ImgBox1 loading="lazy">
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/6f7fa0d7HowToGetSKET_5.png"
              alt="GlobalMarket_graph"
            />
          </ImgBox1>
        </SignContainer>
      </Wrap>
    </Container>
  );
};

export default Com2;
